export enum BioSampleCommentValueType {
  ADDITIONAL = 'ADDITIONAL',
}
